import { ReactElement, useEffect, useLayoutEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import SideNavBar from './SideNavBar';
import Navbar from './Navbar';
import globalRouter from '../_helpers/globalRouter';
import { useData } from '../context/data.context';
import PlanExpiryBanner from './PlanExpiryBanner';
import CalibrationReminderBanner from './CalibrationReminderBanner';

/**
 * A Layout Component that's a combination of navbar and sidebar.
 * @returns - React element that represents the layout component.
 */
export default function Layout(): ReactElement {
  const navigate = useNavigate();
  const { userConfigData } = useData();
  globalRouter.navigate = navigate;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [headerheight, setHeaderHeight] = useState(0);
  /**
   * Function to handle event resize.
   */
  const handleResize = (): void => {
    const element = document.querySelector('header');
    const rect = element?.getBoundingClientRect();
    if (rect?.height) {
      setHeaderHeight(rect.height);
    }
  };
  useLayoutEffect(() => {
    handleResize();
  }, [userConfigData.username]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex h-screen">
      <SideNavBar />
      <Navbar />
      <div
        style={{ paddingTop: headerheight }}
        className="pl-12 sm:pl-16 grow flex flex-col box-border"
      >
        {/* <main className="flex flex-col flex-1"> */}
        <PlanExpiryBanner />
        {/* Calibration reminders are built but not launched: the banner stays
            out of the layout until the feature is announced. The API and the
            settings page behind it are unaffected. */}
        {false && <CalibrationReminderBanner />}
        <div className="px-2 lg:px-6 flex flex-col flex-1 box-border">
          <Outlet />
        </div>
        {/* </main> */}
      </div>
    </div>
  );
}
